import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";
import { Status } from "../types/state";
import { getFieldOrdering } from "../utils/ordering";

export const getCollectionYardsVisitsDetail = (state: RootState) => state.collectionYardsVisitsDetail;
export const getCollectionYardsVisitsDetailStatus = (state: RootState) => state.collectionYardsVisitsDetail.status;
export const getIsCollectionYardsVisitsStatusLoading = (state: RootState): boolean =>
  state.collectionYardsVisitsDetail.status !== Status.success;

export const getCollectionYardsVisitsDetailErrorMsg = (state: RootState) => state.collectionYardsVisitsDetail.errorMsg;

export const getCollectionYardsVisitsDetailVisits = (state: RootState) => state.collectionYardsVisitsDetail.visits;

export const getCollectionYardsVisitsDetailNextPageState = (state: RootState) =>
  state.collectionYardsVisitsDetail.isNextPageEnable;

export const getCollectionYardsVisitsDetailPagination = (state: RootState) =>
  state.collectionYardsVisitsDetail.pagination;
export const getCollectionYardsVisitsDetailOrdering = (state: RootState) => state.collectionYardsVisitsDetail.ordering;
export const getCollectionYardsVisitsDetailFilters = (state: RootState) => state.collectionYardsVisitsDetail.filters;
export const getCollectionYardsVisitsDetailFiltersItems = (state: RootState) =>
  state.collectionYardsVisitsDetail.filters.items;
const getCollectionYardsVisitsDetailFilterValue = (state: RootState, filterId: string) =>
  state.collectionYardsVisitsDetail.filters.items.find((item) => item.id === filterId);
export const getCollectionYardsVisitsDetailFilterValueCached = createSelector(
  [getCollectionYardsVisitsDetailFilterValue],
  (items) => items
);

export const getCollectionYardsVisitsDetailSearch = (state: RootState) => state.collectionYardsVisitsDetail.search;

export const getCollectionYardsVisitsDetailScrollTop = (state: RootState) =>
  state.collectionYardsVisitsDetail.scrollTop;

export const getCollectionYardsVisitsDetailOrderingValue = (state: RootState, fieldName: string) => {
  const ordering = state.collectionYardsVisitsDetail.ordering;
  return getFieldOrdering(fieldName, ordering);
};

const getCollectionYardsVisitsDetailFilterIsActive = (state: RootState, fieldName: string) =>
  !!state.collectionYardsVisitsDetail.filters.items.find((item) => String(item.id).startsWith(fieldName));

export const getCollectionYardsVisitsDetailFilterIsActiveCached = createSelector(
  [getCollectionYardsVisitsDetailFilterIsActive],
  (items) => items
);
